var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.value),expression:"value"}],staticClass:"sticky-pane"})
}
var staticRenderFns = []

export { render, staticRenderFns }